<template>
  <div
    class="card shadow"
    style="height:246px;width:246px"
  >
    <div
      class="card-body rounded-4 transition-shadow position-relative"
      :class="`box-shadow-${color}-300 box-shadow-hover-${color}-300`"
    >
      <span
        v-for="i in 3"
        :key="i"
        class="pills-image"
        :class="[ `pill-card-${index + 1}-${i}` ]"
      />

      <div
        class="position-relative d-flex flex-column"
        style="z-index:30;height:216px;"
      >
        <div class="d-flex mt-3 mx-auto lead fw-bold text-gray-600">
          {{ title }}
        </div>
        <div class="d-flex flex-column m-auto text-center h5">
          <div
            v-for="(inlineText, i) in content"
            :key="`text-${title}-${i}`"
          >
            {{ inlineText }}
          </div>
          <v-icon
            v-if="icon.display"
            :icon="icon.name"
            :folder="icon.folder"
            height="100"
            width="100"
            class="mt-2"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    content: {
      type: [Array],
      default: () => [],
    },
    color: {
      type: String,
      default: 'blue',
    },
    title: {
      type: String,
      default: '',
    },
    index: {
      type: Number,
      default: 1,
    },
    icon: {
      type: Object,
      default: () => ({
        display: false,
        name: null,
      }),
    },
  },
};
</script>

<style scoped>
.pills-image {
  height: 12px;
  border-radius: 60px;
  position: absolute;
  z-index: 3;
}

.pill-card-1-1 {
  left: 20px;
  width: 39px;
  top: 35%;
  background-color: var(--bs-yellow-500);
}
.pill-card-1-2 {
  left: 30px;
  width: 64px;
  bottom: 10%;
  background-color: var(--bs-green-500);
}
.pill-card-1-3 {
  bottom: 30%;
  width: 48px;
  right: 30px;
  background-color: var(--bs-pink-500);
}

.pill-card-2-1 {
  top: 37%;
  right: 20px;
  width: 48px;
  background-color: var(--bs-blue-500);
}
.pill-card-2-2 {
  left: 30px;
  width: 50px;
  height: 10px;
  bottom: 20%;
  background-color: var(--bs-green-500);
}
.pill-card-2-3 {
  bottom: 10%;
  width: 33px;
  right: 30px;
  background-color: var(--bs-pink-500);
}

.pill-card-3-1 {
  top: 30%;
  width: 39px;
  height: 8px;
  right: 30px;
  background-color: var(--bs-yellow-500);
}
.pill-card-3-2 {
  bottom: 17%;
  width: 30px;
  right: 30px;
  background-color: var(--bs-green-500);
}
.pill-card-3-3 {
  bottom: 20%;
  width: 32px;
  left: 40px;
  background-color: var(--bs-blue-500);
}

.pill-card-4-1 {
  top: 35%;
  width: 32px;
  left: 20px;
  background-color: var(--bs-blue-500);
}
.pill-card-4-2 {
  bottom: 20%;
  width: 32px;
  left: 40px;
  background-color: var(--bs-yellow-500);
}
.pill-card-4-3 {
  bottom: 13%;
  width: 48px;
  right: 30px;
  background-color: var(--bs-pink-500);
}
</style>
